import { tw } from "@careinfo/tailwind";
import React from "react";
import ComboboxInput from "../Reusable/ComboboxInput";
import APIS from "../../constant/EndPoint";
import TextField from "../Reusable/TextInput";
import { responsiveClassName } from "../../utils/classNames";
import PhoneNumberField from "../Reusable/PhoneNumberField";
import NumberField from "../Reusable/NumberField";

const CourierPickupRequestForm = (props: any) => {
  const {
    register,
    errors,
    setValue,
    getValues,
    clearErrors,
    control,
    setOpenAddDriverPopup,
    setOpenAddVehiclePopup,
  } = props;
  return (
    <div className={tw`mx-2`}>
      <div
        className={responsiveClassName(
          `grid grid-cols-1 gap-x-4 `,
          "grid grid-cols-2 gap-x-4"
        )}
      >
        <div className={tw`w-full flex `}>
          <div className={tw`w-full`}>
            <ComboboxInput
              url={APIS.VEHICLE}
              queryKey={"vehicle"}
              register={register("vehicle")}
              errors={errors?.vehicle}
              name={"vehicle"}
              label={"Vehicle Number"}
              setValue={setValue}
              placeholder={"Search vehicle"}
              getValues={getValues}
              clearErrors={clearErrors}
            />
          </div>
          <button
            className={tw`border px-4  py-2 h-10 relative top-10 focus:outline-none`}
            type="button"
            onClick={() => setOpenAddVehiclePopup((prev) => !prev)}
          >
            +
          </button>
        </div>

        <div className={tw`w-full flex  `}>
          <div className={tw`w-full`}>
            <ComboboxInput
              url={APIS.DRIVER}
              queryKey={"riders"}
              register={register("driver")}
              errors={errors?.driver}
              name={"driver"}
              label={"Driver"}
              setValue={setValue}
              placeholder={"Search driver"}
              getValues={getValues}
              clearErrors={clearErrors}
            />
          </div>
          <button
            className={tw`border px-4  py-2 h-10 relative top-10 focus:outline-none`}
            type="button"
            onClick={() => setOpenAddDriverPopup((prev) => !prev)}
          >
            +
          </button>
        </div>
      </div>
      <div
        className={responsiveClassName(
          `grid grid-cols-1 gap-x-4`,
          "grid grid-cols-3 gap-x-4"
        )}
      >
        <TextField
          label={"Full Name"}
          register={register(`sender_name`)}
          placeholder={"Enter Full Name"}
          errors={errors?.sender_name}
          name={"sender_name"}
        />
        <div className={tw`mt-3`}>
          <PhoneNumberField
            control={control}
            label={"Phone Number"}
            name={"sender_primary_contact"}
            //@ts-ignore
            errors={errors?.sender_primary_contact}
          />
        </div>
        <TextField
          label={"Address"}
          register={register("sender_address")}
          placeholder={"Enter Address"}
          errors={errors?.sender_address}
          name={"sender_address"}
        />
        <NumberField
          value={getValues("order_count")}
          register={register("order_count")}
          errors={errors?.order_count}
          label={"Total Items"}
          disabled
          setValue={setValue}
          clearErrors={clearErrors}
        />
      </div>
    </div>
  );
};

export default CourierPickupRequestForm;
